import { FC } from 'react';
import IdentificationMethodContent from './IdentificationMethodContent';
import LoanApplicationProcessLayout from 'ui/components/LoanApplicationProcessLayout';

const IdentificationMethodScene: FC = () => (
  <LoanApplicationProcessLayout>
    <IdentificationMethodContent />
  </LoanApplicationProcessLayout>
);

export default IdentificationMethodScene;
